export default {
  universalModal: false,
  deleteModal: false,
  id: null,
}